import { Popconfirm, Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DataUserLoyalty from "../store/DataUserLoyalty";

const LogoutPopconfirm = () => {
    const navigation = useNavigate();
    return (
        <Popconfirm
            title='Вы уверены, что хотите выйти?'
            onConfirm={() => {
                localStorage.clear();

                navigation(
                    `/userLoyalty/auth${
                        DataUserLoyalty.placeId
                            ? `?place_id=${DataUserLoyalty.placeId}`
                            : ""
                    }`
                );
            }}
            okText='Да'
            cancelText='Нет'>
            <Button icon={<LogoutOutlined />} />
        </Popconfirm>
    );
};

export default LogoutPopconfirm;
